export default "/static/ff74791cb99316b4.png"